module.exports = __webpack_public_path__ + "static/media/humza icon-04-02.1f921cf4.png";